import React from "react";
import { useNavigate } from "react-router-dom";
import { createComplementary, getRoomType } from "adminApi/ComplementaryApi/Complementary";
import { ComplementaryRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddComplementaryForm from "./Components/AddComplementaryForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/ComplementaryListField.json";
import useFetchAllData from "Hooks/useFetchAllData";

const AddComplementary = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, ComplementaryRules);

    // Fetch room types for the select dropdown
    const { data: roomTypeOptions, loading: loadingRoomType } = useFetchAllData(getRoomType);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await createComplementary({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, ComplementaryRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Complementary Created Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingRoomType) && <Spinner isSpinner={true} />}
            <AddComplementaryForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                roomTypeOptions={roomTypeOptions || []}
                title="Add Complementary"
            />
        </>
    );
};

export default AddComplementary;
